/**
 * Wrapper ESM que reexporta o módulo CommonJS de common/constants/stablecoin.
 * Permite usar "import { STABLECOIN } from '@common/constants/stablecoin'" no frontend
 * enquanto o common permanece em CommonJS (para backend/Sequelize).
 */
import c from '../../../common/constants/stablecoin.js';

export const STABLECOIN = c.STABLECOIN;
export default c;
